(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
(function () {
  function initGallery(scope) {
    scope.querySelectorAll('[data-lambo-product-root]').forEach(function (root) {
      if (root.dataset.galleryReady) return;
      root.dataset.galleryReady = 'true';
      root.addEventListener('click', function (event) {
        var thumbnail = event.target.closest('[data-lambo-image]');
        if (thumbnail && root.contains(thumbnail)) {
          var image = root.querySelector('#lambo-main-image');
          if (image) {
            image.src = thumbnail.dataset.lamboImage;
            image.removeAttribute('srcset');
            image.alt = thumbnail.dataset.imageAlt || '';
            root.querySelectorAll('[data-lambo-image]').forEach(function (button) {
              button.setAttribute('aria-pressed', button === thumbnail ? 'true' : 'false');
            });
          }
        }
        var step = event.target.closest('[data-lambo-quantity-step]');
        if (step && root.contains(step)) {
          var input = root.querySelector('#lambo-qty');
          if (!input) return;
          if (!Number.isFinite(input.valueAsNumber)) input.value = input.min || '1';
          if (step.dataset.lamboQuantityStep === '1') input.stepUp();
          else input.stepDown();
          input.dispatchEvent(new Event('input', { bubbles: true }));
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initGallery(document); });
  else initGallery(document);
  document.addEventListener('shopify:section:load', function (event) { initGallery(event.target); });
})();

  } catch(e) { console.error(e); }
})();
})();
